import { atomFamily } from 'recoil';
import type { BlockId } from '../types';
import type { PeerGroupIdentifier } from 'venn-api';

export const blockSelectedPeerGroupId = atomFamily<PeerGroupIdentifier | undefined, BlockId>({
  key: 'blockSelectedPeerGroupId',
  default: undefined,
  effects: [],
});
